document.addEventListener("DOMContentLoaded", () => {
  const reviewSection = document.querySelector("#pdp-stamped-reviews");

  document.addEventListener("stamped:reviews:loaded", () => {
    updateReviewSectionStyles();
  });

  function updateReviewSectionStyles() {
    const reviewLabel = reviewSection
      ?.querySelector(".stamped-summary-caption .stamped-summary-text");

    if (reviewLabel) {
      let reviewLabelText = reviewLabel.textContent;
      let newReviewLabelText = reviewLabelText.toLowerCase().replace("based on ", "");
      reviewLabel.textContent = newReviewLabelText;
    }

    const reviewButton = document.createElement("button");
    reviewButton.classList.add("review-button");
    reviewButton.textContent = "Write A Review";
    reviewButton.addEventListener("click", toggleReviewForm);

    function toggleReviewForm() {
      const reviewForm = reviewSection?.querySelector(".new-review-form");
      if (!reviewForm) return;
      reviewForm.style.display = reviewForm.style.display === "block" ? "none" : "block";

      setTimeout(() => {
        const offset = 300;
        const topPosition = reviewForm.getBoundingClientRect().top + window.pageYOffset - offset;
        window.scrollTo({ top: topPosition, behavior: "smooth" });
      }, 50)
    }

    const reviewButtonContainer = reviewSection?.querySelector(".summary-overview");
    reviewButtonContainer?.appendChild(reviewButton);

    normalizeStampedSortSelect();
    normalizeStampedPaginationLinks();
  }

  function normalizeStampedSortSelect() {
    if (!reviewSection) return;

    const sortSelects = reviewSection.querySelectorAll("#stamped-sort-select, .stamped-sort-select");
    sortSelects.forEach((sortSelect) => {
      if (sortSelect.dataset.jumpMenuPatched === "true") return;

      sortSelect.removeAttribute("onchange");

      sortSelect.addEventListener("change", () => {
        if (window.StampedFn && typeof window.StampedFn.sortReviews === "function") {
          window.StampedFn.sortReviews(sortSelect);
        }
      });

      sortSelect.dataset.jumpMenuPatched = "true";
    });
  }

  function normalizeStampedPaginationLinks() {
    if (!reviewSection) return;

    const paginationLinks = reviewSection.querySelectorAll(".stamped-pagination a");
    paginationLinks.forEach((link) => {
      if (link.dataset.paginationPatched === "true") return;

      const onclickValue = link.getAttribute("onclick") || "";
      const hasStampedPaginationHandler = onclickValue.includes("StampedFn.pageReviews");
      if (!hasStampedPaginationHandler) return;

      const pageValue =
        link.getAttribute("data-page") ||
        link.textContent?.trim() ||
        "1";

      link.removeAttribute("onclick");

      const hrefValue = link.getAttribute("href");
      if (!hrefValue || hrefValue === "#") {
        link.setAttribute("href", "#pdp-stamped-reviews");
      }

      link.addEventListener("click", (event) => {
        event.preventDefault();
        if (window.StampedFn && typeof window.StampedFn.pageReviews === "function") {
          window.StampedFn.pageReviews(String(pageValue), "", link);
        }
      });

      link.dataset.paginationPatched = "true";
    });
  }
});
